import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import { validateRuleKeyMap } from './constants';
import { ValidateRule } from '@/coreDomainsModule/constant/validateRules';
import { i18n } from '@/i18n';

/**
 * 取引更新のViewModel
 */
export class UpdateBusinessViewModel {
  private t = i18n.t;
  /**
   * UNASSIGNED_COLUMNをundefinedに変換する
   * @param str - 対象文字列
   */
  public convertUnassingedToUndefined(str: string) {
    return str === UNASSIGNED_COLUMN ? undefined : str;
  }

  /**
   * バリデーションにRequiredがある場合は*を返す
   * @param key - 入力項目のキー
   */
  public getRequiredMark(key: string | number) {
    if (validateRuleKeyMap[key].includes(ValidateRule.Required)) {
      return '*';
    }
    return '';
  }

  /**
   * リードタイムなどの単位をAPIに投げれる形に変換する
   * @param unit - 単位
   */
  public convertDateUnit(unit: string) {
    if (!unit) return '';
    switch (unit) {
      case this.t('日'):
        return 'day';
      case this.t('週'):
        return 'week';
      case this.t('月'):
        return 'month';
      default:
        return '';
    }
  }
}
